import { useEffect, useState } from 'react';
import { format } from 'date-fns';

const MINUTE_MS = 60_000;

export const formatClock = (date: Date): string => format(date, 'HH:mm');

export const useClock = (): string => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;
    const msToNextMinute = MINUTE_MS - (Date.now() % MINUTE_MS);

    const timeout = setTimeout(() => {
      setNow(new Date());
      interval = setInterval(() => setNow(new Date()), MINUTE_MS);
    }, msToNextMinute);

    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, []);

  return formatClock(now);
};
